import { useState, type MouseEvent } from 'react'
import { Button, Space } from 'antd'

import { BuyerHistoryModal } from './BuyerHistoryModal'
import { UserAvatar } from './UserAvatar'
import { NicknameText } from './NicknameText'

interface BuyerLinkProps {
  buyer: { userId: string; nickname: string; profileImageUrl?: string | null }
  /** Show the avatar next to the nickname (list rows, info cards). */
  showAvatar?: boolean
  size?: 'small' | 'default' | 'large' | number
  strong?: boolean
}

/**
 * Buyer nickname rendered as a link that opens the buyer's nickname / delivery-address
 * change history popup. Stops propagation so clickable rows and collapse headers
 * underneath do not also react.
 */
export function BuyerLink({ buyer, showAvatar = false, size = 'small', strong }: BuyerLinkProps) {
  const [open, setOpen] = useState(false)

  const handleOpen = (event: MouseEvent<HTMLElement>): void => {
    event.stopPropagation()
    setOpen(true)
  }

  return (
    <>
      <Space onClick={(event) => event.stopPropagation()}>
        {showAvatar && (
          <UserAvatar
            src={buyer.profileImageUrl ?? undefined}
            nickname={buyer.nickname}
            size={size}
          />
        )}
        <Button
          type="link"
          style={{ padding: 0, height: 'auto', fontWeight: strong ? 600 : undefined }}
          onClick={handleOpen}
          data-testid="buyer-history-link"
        >
          <NicknameText nickname={buyer.nickname} />
        </Button>
      </Space>
      <BuyerHistoryModal buyer={buyer} open={open} onClose={() => setOpen(false)} />
    </>
  )
}
